import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { DefaultAvatar } from '../../icons';
import ProfileSection from './ProfileSection';
import '../Profile.css';

export interface PersonItem {
  name: string;
  avatarUrl?: string;
  avatarShape?: 'circle' | 'rounded';
  route?: string;
  subtitle?: string;
}

export interface PeopleListSectionProps {
  title: string;
  subtitle?: string;
  people: PersonItem[];
  avatarShape?: 'circle' | 'rounded';
  actionLabel?: string;
  actionIcon?: React.ReactNode;
  onAction?: () => void;
  id?: string;
}

export const PeopleListSection: React.FC<PeopleListSectionProps> = ({
  title,
  subtitle,
  people,
  avatarShape = 'circle',
  actionLabel,
  actionIcon,
  onAction,
  id,
}) => {
  const navigate = useNavigate();

  return (
    <ProfileSection title={title} subtitle={subtitle} id={id}>
      <div className="profile-people__list">
        {people.map((person, i) => (
          <div
            key={i}
            className="profile-people__item"
            onClick={person.route ? () => navigate(person.route!) : undefined}
            role={person.route ? 'button' : undefined}
          >
            <div className={`profile-people__avatar profile-people__avatar--${person.avatarShape || avatarShape}`}>
              {person.avatarUrl ? (
                <img src={person.avatarUrl} alt={person.name} />
              ) : (
                <DefaultAvatar size={40} />
              )}
            </div>
            <div className="profile-people__info">
              <span className="profile-people__name">{person.name}</span>
              {person.subtitle && <span className="profile-people__subtitle">{person.subtitle}</span>}
            </div>
          </div>
        ))}
      </div>
      {actionLabel && onAction && (
        <div className="profile-people__action">
          <Button type="primary" shape="round" onClick={onAction}>
            {actionIcon} {actionLabel}
          </Button>
        </div>
      )}
    </ProfileSection>
  );
};

export default PeopleListSection;
